export default [
  {
    img: "/product/610b62385bf64284a47aaec7ef06be41_800x800.webp",
    label: "布电线",
    type: "13",
  },
  {
    img: "/product/38280a3129cdf17339b0574ac68be736_800x800.webp",
    label: "布电线",
    type: "13",
  },
  {
    img: "/product/2f4f7f959bc4c2747c010382162a0c83_800x800.webp",
    label: "布电线",
    type: "13",
  },
  {
    img: "/product/446ea399af05d311fd3b4ff92f6d73cb_800x800.webp",
    label: "布电线",
    type: "13",
  },
  {
    img: "/product/257be50df290fdc8329600d10396f21c_800x800.webp",
    label: "布电线",
    type: "13",
  },
  {
    img: "/product/eb5dae1c776fe9776e14781c021824aa_800x800.webp",
    label: "布电线",
    type: "13",
  },
  {
    img: "/dianlidianlan/1.webp",
    label: "电力电缆",
    type: "14",
  },
  {
    img: "/dianlidianlan/ZCYJV 4X16.webp",
    label: "电力电缆",
    type: "14",
  },
  {
    img: "/dianlidianlan/7.webp",
    label: "电力电缆",
    type: "14",
  },
  {
    img: "/dianlidianlan/ZCYJV 4X25+1X16.webp",
    label: "电力电缆",
    type: "14",
  },
  {
    img: "/dianlidianlan/ZCYJV 4X70+1X35.webp",
    label: "电力电缆",
    type: "14",
  },
  {
    img: "/dianlidianlan/ZCYJV 3X10+1X6.webp",
    label: "电力电缆",
    type: "14",
  },

  {
    img: "/dianlidianlan/3.webp",
    label: "电力电缆",
    type: "14",
  },
  {
    img: "/dianlidianlan/4.webp",
    label: "电力电缆",
    type: "14",
  },
  {
    img: "/dianlidianlan/ZCYJV 3X120+2X70.webp",
    label: "电力电缆",
    type: "14",
  },
  {
    img: "/dianlidianlan/ZCYJV 3X150+1X70.webp",
    label: "电力电缆",
    type: "14",
  },
  {
    img: "/dianlidianlan/6.webp",
    label: "电力电缆",
    type: "14",
  },
  {
    img: "/dianlidianlan/5.webp",
    label: "电力电缆",
    type: "14",
  },

  // {
  //   img: "/product/67934d0e5e322b1a6b7168b18baa7e7c_800x800.webp",
  //   label: "电力电缆",
  //   type: "14",
  // },
  // {
  //   img: "/product/3ee9c39e56b29896c6a4000bd560a5c0_800x800.webp",
  //   label: "电力电缆",
  //   type: "14",
  // },
  // {
  //   img: "/product/58b93bfba2b354673b707fb78789b20a_800x800.webp",
  //   label: "电力电缆",
  //   type: "14",
  // },
  // {
  //   img: "/product/20ef201f119ed60b6f7fe3f3cb0e5a09_800x800.webp",
  //   label: "电力电缆",
  //   type: "14",
  // },
  // {
  //   img: "/product/06dee031aae15fbd004926273ab30769_800x800.webp",
  //   label: "电力电缆",
  //   type: "14",
  // },
  // {
  //   img: "/product/06dee031aae15fbd004926273ab30769_800x800.webp",
  //   label: "电力电缆",
  //   type: "14",
  // },
  // {
  //   img: "/product/6ff46f8987f15c74c4df9151143b5b4b_800x800.webp",
  //   label: "橡套电缆",
  //   type: "15",
  // },
  // {
  //   img: "/product/067934932ac0d52b3285137a2d5044f1_800x800.webp",
  //   label: "橡套电缆",
  //   type: "15",
  // },
  // {
  //   img: "/product/d30e07e0e52da70902dfe791734fbc26_800x800.webp",
  //   label: "橡套电缆",
  //   type: "15",
  // },
  // {
  //   img: "/product/ace8ee643b11a785e7fa3b48de302602_800x800.webp",
  //   label: "橡套电缆",
  //   type: "15",
  // },
  // {
  //   img: "/product/b1943cee40118d980b4c292cab032bd5_800x800.webp",
  //   label: "橡套电缆",
  //   type: "15",
  // },
  // 控制电缆
  {
    img: "/product/e81473357d6aa2f8c6c297b97466eed0_800x800.webp",
    label: "控制电缆",
    type: "16",
  },
  {
    img: "/product/1ba8e1f4e7c3241a54593f8d2f30d938_800x800.webp",
    label: "控制电缆",
    type: "16",
  },
  {
    img: "/product/85cf92d1b145202a8717d88abf1dd83e_800x800.webp",
    label: "控制电缆",
    type: "16",
  },
  {
    img: "/product/7fbea58142cbcf884f5116db25511482_800x800.webp",
    label: "控制电缆",
    type: "16",
  },
  {
    img: "/product/549398d4afb7e6fbfe6b749fe5c07193_800x800.webp",
    label: "控制电缆",
    type: "16",
  },
  {
    img: "/product/30e0f221b86e617dff5c1bc3bc0e93ef_800x800.webp",
    label: "控制电缆",
    type: "16",
  },
  // 低烟无卤电缆
  {
    img: "/product/f27221fac6672fba401256fa929df913_800x800.webp",
    label: "低烟无卤电缆",
    type: "17",
  },
  {
    img: "/product/1e9887a06de0c680a6f5137b06efde58_800x800.webp",
    label: "低烟无卤电缆",
    type: "17",
  },
  {
    img: "/product/4646cf99e901176b6366a155265414a3_800x800.webp",
    label: "低烟无卤电缆",
    type: "17",
  },
  {
    img: "/product/a0bffe481c73b8f1fa3efe7c83996c65_800x800.webp",
    label: "低烟无卤电缆",
    type: "17",
  },
  {
    img: "/product/dd0259c59c9ed412caff930173240bc2_800x800.webp",
    label: "低烟无卤电缆",
    type: "17",
  },
  {
    img: "/product/00f6c951c42874d4179eb5b56cf0dec2_800x800.webp",
    label: "低烟无卤电缆",
    type: "17",
  },
  {
    img: "/product/41b31b025b40f2b15b4a653c440c0378_800x800.webp",
    label: "低烟无卤电缆",
    type: "17",
  },
  // 高压电缆 18

  {
    img: "/product/9c88df8c6256fc8cb0db3b87aa65b971_800x800.webp",
    label: "高压电缆",
    type: "18",
  },
  {
    img: "/product/5032de298b16dc6699bb5e2753e1cf6d_800x800.webp",
    label: "高压电缆",
    type: "18",
  },
  {
    img: "/product/4bdea110bfcfafe852839335f00f6c7f_800x800.webp",
    label: "高压电缆",
    type: "18",
  },
  {
    img: "/product/8b41ce5e5eba70d956521977bcf76659_800x800.webp",
    label: "高压电缆",
    type: "18",
  },
  {
    img: "/product/1679e7a3de72c612a15590500609aa27_800x800.webp",
    label: "高压电缆",
    type: "18",
  },
  // 护套线
  {
    img: "/product/c43793d3e7cd3931fc4041f54e90025b_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/5d8a3e7184c7a98ebf2b8cb3eb9284c3_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/50b08749b22e2db86418a1803b143054_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/f7d5fb52628c9dc4417400ff20f4101b_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/d77d737892a8cf69838384680bed2914_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/d2b2f76a0c02615d1d0d8fb34a8fd8c5_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/6d2671eaeb332a74a5238925f97f83a8_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/17243bc4959a0e99704d0c6104d04750_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/63a8bc289392f5b758d334e37b36d36b_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/c5537c7c28889d2587401cb9c369f151_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/7c81366437341aa391d5167894a9041e_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/c722fc6299f001222d3bd791e5898257_800x800.webp",
    label: "护套线",
    type: "19",
  },
  {
    img: "/product/f6b4147faea25ea694bb4adc3116f24e_800x800.webp",
    label: "集束电缆",
    type: "20",
  },
  {
    img: "/product/67cd1fec1309774cdbceedf2d5618adf_800x800.webp",
    label: "集束电缆",
    type: "20",
  },
  //架空电缆
  {
    img: "/product/44ef6d85338a1623abf74ff3026dab5a_800x800.webp",
    label: "架空电缆",
    type: "21",
  },
  {
    img: "/product/203481398f55762720ca1bbee2158cf1_800x800.webp",
    label: "架空电缆",
    type: "21",
  },
  {
    img: "/product/6f56bb7a74de6689f52170c01a729063_800x800.webp",
    label: "架空电缆",
    type: "21",
  },
  {
    img: "/product/7b122affefed841c2993d58d45888cfd_800x800.webp",
    label: "架空电缆",
    type: "21",
  },
  // 矿物质电缆
  {
    img: "/product/e5fdb208ad63d912c601347f0fb07ded_800x800.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/product/54d63c0f190ef9e03b537425937fbb7a_800x800.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/product/d21afe7a10fd6bd8898207d20bc9ae75_800x800.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/product/e548a0a89d1ee5941a608e03f82ad29e_800x800.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/kuangwuzhi/20241115121009.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/kuangwuzhi/20241115121130.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/kuangwuzhi/20241115121146.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/kuangwuzhi/20241115121158.webp",
    label: "矿物质电缆",
    type: "22",
  },
  // {
  //   img: "/kuangwuzhi/20241115121210.webp",
  //   label: "矿物质电缆",
  //   type: "22",
  // },
  // {
  //   img: "/kuangwuzhi/20241115121219.webp",
  //   label: "矿物质电缆",
  //   type: "22",
  // },
  {
    img: "/kuangwuzhi/20241115121237.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/kuangwuzhi/20241115121257.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/kuangwuzhi/20241115121305.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/kuangwuzhi/20241115121314.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/kuangwuzhi/20241115121323.webp",
    label: "矿物质电缆",
    type: "22",
  },
  {
    img: "/kuangwuzhi/20241115121331.webp",
    label: "矿物质电缆",
    type: "22",
  },
  //铝合金电缆
  {
    img: "/product/0b249cd668d0f9b56cca96a88720ca6d_800x800.webp",
    label: "铝合金电缆",
    type: "23",
  },
  {
    img: "/product/51f0796fc5e5ee04081e256bd4899b3d_800x800.webp",
    label: "铝合金电缆",
    type: "23",
  },
  {
    img: "/product/61ccfdad3b95ddf3fe48cbad7efef73f_800x800.webp",
    label: "矿铝合金电缆物质电缆",
    type: "23",
  },
  {
    img: "/product/288b04bdf9ea3fe66f00be292bcd4ee4_800x800.webp",
    label: "铝合金电缆",
    type: "23",
  },
  //特种电缆
  {
    img: "/product/d49aba3abd04b1277a3289a9284db7a9_800x800.webp",
    label: "特种电缆",
    type: "24",
  },
  {
    img: "/product/6346702e65b95e432afdadfbb742b852_800x800.webp",
    label: "特种电缆",
    type: "24",
  },
  {
    img: "/product/8ee3dc3ac0b1f172e809545178e8aa71_800x800.webp",
    label: "特种电缆",
    type: "24",
  },
  {
    img: "/product/2ea1f767ac1d80e21f32fc4507ea4ec3_800x800.webp",
    label: "特种电缆",
    type: "24",
  },
  //通信电缆
  // {
  //   img: "/product/3f378af5a5d25bb256f64bbf617f20a5_800x800.webp",
  //   label: "通信电缆",
  //   type: "25",
  // },
  // {
  //   img: "/product/f2c0b8ab966b39dba5d0df02f98cb78c_800x800.webp",
  //   label: "通信电缆",
  //   type: "25",
  // },
  // {
  //   img: "/product/00a1501ea3ae4f981402010ffd5187a4_800x800.webp",
  //   label: "通信电缆",
  //   type: "25",
  // },
  // {
  //   img: "/product/a66077846f179bf40407ccdcfe5acbf5_800x800.webp",
  //   label: "通信电缆",
  //   type: "25",
  // },
  // {
  //   img: "/product/b3652e55586381db3b1c0420b35244cf_800x800.webp",
  //   label: "通信电缆",
  //   type: "25",
  // },
  // {
  //   img: "/product/43dc5601d5ca3cd665c239616638dcae_800x800.webp",
  //   label: "通信电缆",
  //   type: "25",
  // },
  // 阻燃电缆
  {
    img: "/product/4ec2b1f7dde2884c0216df2820a43315_800x800.webp",
    label: "阻燃电缆",
    type: "26",
  },
  {
    img: "/product/427e6db07385dc4d5988273186e12ecc_800x800.webp",
    label: "阻燃电缆",
    type: "26",
  },
  {
    img: "/product/330919ec1e5135ced2f2c6cf8da34ce9_800x800.webp",
    label: "阻燃电缆",
    type: "26",
  },
  {
    img: "/product/e74f3110fa34fd7635ea8eab9f8a51b4_800x800.webp",
    label: "阻燃电缆",
    type: "26",
  },
  {
    img: "/product/429e9fac24f38263e7e8277770c7d1a3_800x800.webp",
    label: "阻燃电缆",
    type: "26",
  },
  {
    img: "/product/c2bf26624fb939a627c9d3ebad77aae6_800x800.webp",
    label: "阻燃电缆",
    type: "26",
  },
];
